import { render, staticRenderFns } from "./UserInteractions.vue?vue&type=template&id=157b617c&scoped=true"
import script from "./UserInteractions.vue?vue&type=script&lang=js"
export * from "./UserInteractions.vue?vue&type=script&lang=js"
import style0 from "./UserInteractions.vue?vue&type=style&index=0&id=157b617c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157b617c",
  null
  
)

export default component.exports